import { ReactElement } from 'react';
import { useLocation } from 'react-router-dom';
import AgentStudioLinkOut from 'studio5/components/AgentStudioLinkOut';
import { useAgentStudioNavigation } from 'studio5/hooks';

import LoadingOverlay from 'studio-shell/components/LoadingOverlay';
import { isStudio5Route } from './route-manifest';

type AppRouterProps = {
  studio5Content: ReactElement;
  studioClassicContent: ReactElement;
};

export const AppRouter = ({
  studio5Content,
  studioClassicContent,
}: AppRouterProps) => {
  const { pathname } = useLocation();
  const navigation = useAgentStudioNavigation(pathname);

  // Hold until flags resolve so the Studio page doesn't flash before the swap.
  if (navigation.kind === 'pending') {
    return <LoadingOverlay />;
  }

  // Unmounts the owning sub-app, as any studio5↔classic switch does.
  if (navigation.kind === 'link-out') {
    return (
      <AgentStudioLinkOut path={navigation.path} content={navigation.content} />
    );
  }

  if (isStudio5Route(pathname)) {
    return studio5Content;
  }

  return studioClassicContent;
};
